import React, { useState, useEffect, useRef } from "react";
import ReactTable from "react-table";
import Button from "components/button/Button";
import Pagination from "components/common/Pagination";
import "react-table/react-table.css";
import { withRouter } from "react-router";
import Loader from "../common/Loader";
import Toaster from "../common/Toaster";
import {
  FAX_STATUS,
  FAX_TYPE,
  MODULE_NAMES,
  PERMISSION_TYPE,
  TABLE
} from "../../helper/constant";
import EncryptDecrypt from "../../api/EncryptDecrypt";
import CommonModel from "components/common/CommonModel";
import EfaxManagementServices from "api/EfaxMangementServices";
import moment from "moment";
import EditEfaxModal from "./EditEfaxModal";
import Select from "react-select";
import PatientModal from "./PatientModal";
import ArchiveModal from "components/common/ArchiveModal";
import { hasAccess } from "util/sidebar";

const InboxTable = props => {
  const { permissions } = props;
  const toaster = useRef();
  const [tblData, settblData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [pages, setPages] = useState(0);
  const [activePage, setActivePage] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [field, setField] = useState("received_at");
  const [sortBy, setSortBy] = useState("DESC");
  const [patientModal, setPatientModal] = useState(false);
  const [modal, setModal] = useState(false);
  const [editedData, setEditedData] = useState({});
  const [customModal, setCustomModal] = useState(false);
  const [status, setStatus] = useState(null);
  const [id, setId] = useState("");
  const [pendingStatus, setPendingStatus] = useState(null);
  const [pendingId, setPendingId] = useState("");

  useEffect(() => {
    if (hasAccess(MODULE_NAMES.EFAX_INBOX, PERMISSION_TYPE.VIEW, permissions)) {
      getList(field, sortBy, searchText, activePage + 1);
      setPages(10);
    }
  }, [props]);

  function toggle() {
    setModal(!modal);
  }
  function togglePatientModal() {
    setPatientModal(!patientModal);
  }
  function activeToggle() {
    setCustomModal(false);
  }

  const handleDownload = (faxId, attachementId) => {
    const params = {
      fax_id: faxId,
      attachment_id: attachementId
    };

    EfaxManagementServices.download(params)
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data.status) {
          if (toaster.current) toaster.current.success(data.message);
          window.open(data.data, "_blank");
        } else {
          if (toaster.current) toaster.current.error(data.message);
        }
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err.response);
      });
  };

  const statusUpdate = (id, event) => {
    setId(id);
    setStatus(event);
    setCustomModal(true);
  };

  const callUpdateStatusAPi = (data, event) => {
    if (event.value === "unread") {
      updateStatusHandler(data?.id, event);
    } else if (data.status !== "pending") {
      setPendingId(data?.id);
      setPendingStatus(event);
      setModal(true);
    }
  };

  const updateStatusHandler = (faxId, selectedOption, fromModal = false) => {
    const params = {
      fax_id: faxId,
      status: selectedOption?.value
    };
    setLoader(true);
    if (fromModal) setCustomModal(false);

    EfaxManagementServices.updateStatus(params)
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data.status) {
          if (toaster.current) toaster.current.success(data.message);
          getList(field, sortBy, searchText, activePage + 1);
          setLoader(false);
        } else {
          if (toaster.current) toaster.current.error(data.message);
          setLoader(false);
        }
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err.response);
        setLoader(false);
      });
  };

  const options = [
    { value: "unread", label: "Unread" },
    { value: "pending", label: "Pending" },
    { value: "archived", label: "Archived" }
  ];

  const columns = [
    {
      Header: "ID",
      accessor: "id",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class sort-sign",
      width: 70,
      sortable: true
    },
    {
      Header: "To Number",
      accessor: "to_number",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class sort-sign",
      width: 150,
      sortable: true,
      Cell: props =>
        props.original.to_number
          .toString()
          .replace(/\D+/g, "")
          .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
    },
    {
      Header: "From Number",
      accessor: "from_number",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class sort-sign",
      width: 150,
      sortable: true,
      Cell: props =>
        props.original.from_number
          .toString()
          .replace(/\D+/g, "")
          .replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3")
    },
    {
      Header: "Date Received",
      accessor: "received_at",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class sort-sign",
      width: 200,
      sortable: true,
      Cell: props =>
        props.original.received_at
          ? moment
              .utc(props.original.received_at)
              .local()
              .format("MM/DD/YYYY HH:mm")
          : ""
    },
    {
      Header: "Status",
      accessor: "status",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class sort-sign",
      width: 150,
      sortable: true,

      Cell: props => (
        <Select
          style={{ width: "80px" }}
          menuPortalTarget={document.body}
          menuPosition={"fixed"}
          value={{
            value: `${props.original.status}`,
            label: FAX_TYPE[`${props.original.status}`]
          }}
          onChange={evt => {
            setEditedData({ ...props.original });
            if (evt.value !== "archived") {
              callUpdateStatusAPi(props?.original, evt);
            } else {
              statusUpdate(props?.original?.id, evt);
            }
          }}
          options={options}
        />
      )
    },
    {
      Header: "Pages",
      accessor: "pages",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class sort-sign",
      width: 90,
      sortable: true
    },
    {
      Header: "Category",
      accessor: "service",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class sort-sign",
      width: 150,
      sortable: true,
      Cell: props => props?.original?.service && props?.original?.service.name
    },
    {
      Header: "Notes",
      accessor: "notes",
      className: "",
      filterable: false,
      headerClassName: "react-table-header-class sort-sign",
      width: 200,
      sortable: true
    },

    {
      Header: "Action",
      accessor: "action",
      className: "",
      headerClassName: "react-table-header-class",
      sortable: false,
      filterable: false,
      width: 300,
      Cell: props => (
        <div className="react-action-class">
          <Button
            className="c-btn c-info mr-10"
            onClick={() => viewAction(props.original)}
          >
            <div className="fs-14 medium-text" title="View">
              <i className="fas fa-eye" />
            </div>
          </Button>
          {hasAccess(
            MODULE_NAMES.EFAX_INBOX,
            PERMISSION_TYPE.EDIT,
            permissions
          ) && (
            <Button
              className="c-btn c-success mr-10"
              onClick={() => {
                setModal(!modal);
                setEditedData({ ...props.original });
              }}
            >
              <div className="fs-14 medium-text" title="Edit">
                <i className="fas fa-edit" />
              </div>
            </Button>
          )}
          {hasAccess(
            MODULE_NAMES.EFAX_INBOX,
            PERMISSION_TYPE.EDIT,
            permissions
          ) && (
            <Button
              className="c-btn c-info mr-10"
              onClick={() =>
                handleDownload(props?.original?.id, props?.original?.attachment)
              }
            >
              <div className="fs-14 medium-text" title="Download">
                <i className="fas fa-download" />
              </div>
            </Button>
          )}
          {hasAccess(
            MODULE_NAMES.EFAX_INBOX,
            PERMISSION_TYPE.EDIT,
            permissions
          ) && (
            <Button
              className="c-btn c-focus"
              onClick={() => {
                setPatientModal(!patientModal);
                setEditedData({ ...props.original });
              }}
              disabled={props?.original?.status !== FAX_STATUS["PENDING"]}
            >
              <div className="fs-14 medium-text" title="Attach to Patient">
                <i class="fas fa-paperclip" />
              </div>
            </Button>
          )}
        </div>
      ) // Custom cell components!
    }
  ];

  const onChangePageGetData = state => {
    if (state.page !== activePage) {
      // alert("on page change you have to call api and get data");
    }
  };

  const viewAction = props => {
    window.open(props.attachment_url, "_blank");
  };

  function getList(
    field = "created_at",
    sort_by = "DESC",
    search = "",
    page = "1"
  ) {
    const params = {
      order: sort_by,
      sort_by: field,
      search: search,
      page: page,
      service_id:
        props?.auth?.admin_role_id > 2 ? props?.auth?.service_id : undefined
    };
    setLoader(true);
    EfaxManagementServices.list(params)
      .then(res => {
        let data = EncryptDecrypt.decrypt(res.data);
        if (data.status) {
          settblData(data.data.rows);
          setPages(Math.ceil(data.data.count / TABLE.LIMIT));
          setLoader(false);
        } else {
          if (toaster.current) toaster.current.error(data.message);
        }
      })
      .catch(err => {
        if (toaster.current) toaster.current.error(err.response);
      });
  }

  return (
    <div>
      <div className="plr-15">
        <div className="roe-card-style mtb-15">
          <div className="roe-card-header module-header">
            <div className="flex-1 fs-16 demi-bold-text">
              <span className="hash"># </span> eFax Inbox List
            </div>
            <div className="mr-10">
              <input
                value={searchText}
                onChange={e => {
                  setSearchText(e.target.value);
                  const search = e.target.value;
                  setLoader(true);
                  setActivePage(0);
                  setTimeout(() => {
                    getList(field, sortBy, search, 1);
                  }, 500);
                }}
                type="text"
                placeholder="Search..."
                className="fs-14 medium-text plr-10 form-control react-form-input"
              />
            </div>
          </div>
          <div className="roe-card-body">
            <ReactTable
              style={{
                border: "none",
                boxShadow: "none"
              }}
              data={tblData}
              columns={columns}
              defaultPageSize={10}
              minRows={2}
              manual
              defaultFilterMethod={(filter, row) => {
                const id = filter.pivotId || filter.id;

                return row[id] !== undefined
                  ? String(row[id].toLowerCase()).includes(
                      filter.value.toLowerCase()
                    )
                  : true;
              }}
              className="-striped -highlight custom-react-table-theme-class"
              pages={pages}
              page={activePage}
              PaginationComponent={Pagination}
              loading={loader}
              LoadingComponent={Loader}
              onFetchData={onChangePageGetData}
              onPageChange={pageIndex => {
                setActivePage(pageIndex);
                getList(field, sortBy, searchText, pageIndex + 1);
              }}
              onSortedChange={sortProperties => {
                const sort = sortProperties[0].desc ? "DESC" : "ASC";
                setSortBy(sort);
                setActivePage(0);
                setField(sortProperties[0].id);
                getList(sortProperties[0].id, sort, searchText, 1);
              }}
            />
          </div>
        </div>
      </div>
      <Toaster ref={toaster} />

      <CommonModel
        modal={modal}
        toggle={toggle}
        children={
          <EditEfaxModal
            editedData={editedData}
            toggle={toggle}
            pageRefresh={() => {
              getList(field, sortBy, searchText, activePage + 1);
            }}
            {...props}
            callUpdateStatusAPiHandler={() =>
              updateStatusHandler(pendingId, pendingStatus, false)
            }
          />
        }
      />
      <CommonModel
        modal={patientModal}
        toggle={togglePatientModal}
        children={
          <PatientModal
            editedData={editedData}
            toggle={togglePatientModal}
            pageRefresh={() => {
              getList(field, sortBy, searchText, activePage + 1);
            }}
            {...props}
          />
        }
      />
      <CommonModel
        modal={customModal}
        toggle={activeToggle}
        children={
          <ArchiveModal
            text={"Are you sure you want to archive this fax?"}
            activeInactiveStatusHandler={() =>
              updateStatusHandler(id, status, true)
            }
            activeToggle={activeToggle}
          />
        }
      />
    </div>
  );
};

export default withRouter(InboxTable);
